import TablePlainDataCell from './TablePlainDataCell';

interface UserProfileCellProps {
    imageUrl?: string;
    title?: string;
    subTitle?: string;
    dataLabel: string | number | undefined;
}

export default ({ imageUrl, title, subTitle, dataLabel }: UserProfileCellProps) => {
    return (
        <TablePlainDataCell dataLabel={dataLabel}>
            <div className="inline-flex items-center">
                {imageUrl && (
                    <div className="flex-shrink-0">
                        <a href="#" className="block relative">
                            <img alt="profil" src={imageUrl} className="mx-auto object-cover rounded-full h-8 w-8 " />
                        </a>
                    </div>
                )}
                <div className="ml-3">
                    {title && <p className="text-gray-900 whitespace-no-wrap text-base text-left">{title}</p>}
                    {subTitle && <p className="text-gray-500 whitespace-no-wrap text-sm">{subTitle}</p>}
                </div>
            </div>
        </TablePlainDataCell>
    );
};
